import { PortableText } from "@portabletext/react";
import { Link } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import React from "react";
import { slug } from "../../../utils/slug";
import AdvantagesButton from "./button";

const Advantages = ({ data }) => {
  return (
    <section
      id={data?.sectionId ?? ""}
      className="py-16 bg-slate-100 md:py-24 xl:py-32"
    >
      <div className="max-w-[1366px] mx-auto px-5 md:px-8 lg:px-12">
        {/* Header Section */}
        <div className="mb-16 lg:mb-20">
          <div className="grid items-end grid-cols-1 gap-12 lg:grid-cols-2 lg:gap-16">
            {/* Left Column - Title */}
            <div className="space-y-4">
              {data.caption && (
                <span className="inline-block text-sm font-medium tracking-wider uppercase text-logo1">
                  {data.caption}
                </span>
              )}
              <h2 className="text-4xl font-bold leading-tight text-black md:text-5xl lg:text-6xl xl:text-7xl">
                {data.title}
              </h2>
              {data._rawDescription && (
                <div className="text-lg leading-relaxed text-gray-600">
                  <PortableText value={data._rawDescription} />
                </div>
              )}
            </div>

            {/* Right Column - Description */}
            <div className="space-y-6">
              {data.enableButton && <AdvantagesButton button={data.button} />}
            </div>
          </div>
        </div>

        {/* Advantages Grid */}
        <div
          className={`grid grid-cols-1 md:grid-cols-2 gap-8 ${
            data.advantagesList.length % 3 === 0
              ? "lg:grid-cols-3"
              : "lg:grid-cols-2"
          }`}
        >
          {data.advantagesList?.map((item, key) => {
            if (item.enable) {
              return (
                <Link
                  to={slug(item?.slug?.current ?? "")}
                  key={key}
                  className="overflow-hidden transition-all duration-300 transform bg-white border border-gray-200 rounded-lg shadow-sm group hover:shadow-xl hover:-translate-y-2"
                >
                  {/* Icon Section */}
                  <div className="relative transition-all duration-300 bg-gradient-to-br from-gray-50 to-gray-100 group-hover:from-logo1/10 group-hover:to-logo1/5">
                    <div className="flex items-center justify-center">
                      <div className="w-full h-[250px] group-hover:scale-110 transition-transform duration-300">
                        <GatsbyImage
                          image={item.image.image.asset.gatsbyImageData}
                          alt={item.image.altText}
                          className="object-cover w-full h-full"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Content Section */}
                  <div className="p-8 space-y-4">
                    <h3 className="text-2xl font-bold leading-tight text-black transition-colors duration-200 group-hover:text-gray-800">
                      {item.title}
                    </h3>
                    <p className="text-lg leading-relaxed text-gray-600">
                      {item.description}
                    </p>

                    {/* Learn More Indicator */}
                    {/* <div className="flex items-center pt-2 transition-all duration-200 transform translate-y-2 opacity-0 group-hover:opacity-100 group-hover:translate-y-0">
                      <span className="text-base font-medium text-logo1">
                        Learn More
                      </span>
                      <svg
                        className="w-4 h-4 ml-2 transition-transform duration-200 transform text-logo1 group-hover:translate-x-1"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fillRule="evenodd"
                          d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </div> */}
                  </div>
                </Link>
              );
            }
          })}
        </div>
      </div>
    </section>
  );
};

export default Advantages;
